import { TabBarSkeleton } from "@/components/TabBarSkeleton";
import { EarningsSkeleton } from "./earnings/EarningsSkeleton";

/**
 * Full-page skeleton for the Finances route's pendingComponent.
 * Shows tab bar and the default Earnings tab skeleton.
 */
export function FinancesPageSkeleton() {
	return (
		<div className="flex flex-col gap-6">
			<TabBarSkeleton tabWidths={[70, 60, 130]} />
			<div className="py-4">
				<EarningsSkeleton />
			</div>
		</div>
	);
}
